import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export interface OpLiveRecommendationsElement extends HTMLElement {
  'block-name'?: string;
  variant?: string;
  preset?: string;
  headline?: string;
  description?: string;
}

const OpLiveRecommendations = createWrapper<OpLiveRecommendationsElement>('op-live-recommendations');

export default OpLiveRecommendations;
